<template>
  <div class="one-column-width">



    <!-- form start -->
    <v-card class="r_tabsform_card mb-5" >
    <v-card-title class="r_form_card_title ext_pdg_to_lvl"> Create an Event</v-card-title>
    <hr class="r_form_card_top_hr">

    <div class="col-md-11  m-5">
        <div class="col-md-12 row mb-5 pb-5">
          <div class="col-md-4">
              <!-- <label>Name <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Event Name" />
          </div>

          <div class="col-md-4">
              <div class="row">
                  <div class="col-4">
                    <label>Starting Date <span class="text-danger">*</span></label>
                  </div>
                  <div class="col-6">
                    <input type="date" class="r_formtabs_inputs m-0 w-100" />
                  </div>
              </div>
          </div>

          <div class="col-md-4">
              <div class="row">
                  <div class="col-4">
                    <label>Ending Date <span class="text-danger">*</span></label>
                  </div>
                  <div class="col-6">
                    <input type="date" class="r_formtabs_inputs m-0 w-100" />
                  </div>
              </div>
          </div>

          <div class="col-md-3">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Country" />
          </div>

          <div class="col-md-3">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="City" />
          </div>

          <div class="col-md-3">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Institute" />
          </div>

          <div class="col-md-3">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Event Venue" />
          </div>

          <div class="col-md-4">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Contact" />
          </div>

          <div class="col-md-4">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Email" />
          </div>

          <div class="col-md-4">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Event Website" />
          </div>

          <div class="col-md-12">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <textarea class="r_formtabs_text_area m-0 w-100" placeholder="Event Descrption" rows="5"></textarea>
          </div>

          <div class="col-md-6">
              <label>Event Type: <span class="text-danger">*</span></label>
              <input id="open" type="radio" class="mr-2 ml-5" />
              <label for="open">Open</label>
              <input id="registration_required" type="radio" class="mr-2 ml-5" />
              <label for="registration_required">Registration Required</label>
          </div>

          <div class="col-md-6">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input type="file" class="r_formtabs_inputs m-0 w-100" />
          </div>
        </div>


          <hr class="r_form_card_top_hr">
          <div class="row">
              <div class="col-9">
                  <v-card-title class="r_form_card_title ext_pdg_to_lvl p-0"> More Details</v-card-title>
              </div>
              <div class="col-3">
                <input
                    type="radio"
                    id="more_dets_on"
                    class="r_form_top_search mr-2"
                />
                <label for="more_dets_on">On</label>
                <input
                    type="radio"
                    id="more_dets_off"
                    class="r_form_top_search ml-5 mr-2"
                />
                <label for="more_dets_off">Off</label>
              </div>
          </div>
          <hr class="r_form_card_top_hr">


        <div class="row my-5 py-5">
          <div class="col-md-6">
              <label>Invite people from your Friends List</label>
          </div>

          <div class="col-md-6">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Friends Name Goes Here" />
          </div>

        </div>

        <div class="row my-5 py-5">

          <div class="col-md-12">
              <label>Invite Specific group of People</label>
          </div>

          <div class="col-md-6">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Select Institution" />
          </div>

          <div class="col-md-6">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Select Department" />
          </div>

          <div class="col-md-6">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Select Degree Program" />
          </div>

          <div class="col-md-6">
              <!-- <label>Institute <span class="text-danger">*</span></label> -->
              <input class="r_formtabs_inputs m-0 w-100" placeholder="Select Year of Graduation" />
          </div>

        </div>

        <hr class="r_form_card_top_hr">

        <div class="mt-5">
            <input id="checkbox1" type="checkbox" class="mr-2" />
            <label for="checkbox1">Show it on university’s calendar of events</label>
        </div>
        <div>
            <input id="checkbox2" type="checkbox" class="mr-2" />
            <label for="checkbox2">Send email message to target audienc</label>
        </div>
        <div>
            <input id="checkbox3" type="checkbox" class="mr-2" />
            <label for="checkbox3">Send Auto thanks message to all attendees</label>
        </div>

        <div class="row mt-5 pt-5">

            <div class="col-md-6">
            <button
                type="button"
                class="r_form_add_more_btnnn m-0"
            >
                Post
            </button>
            <button
                type="button"
                class="r_form_cancel_more_btnnn m-0"
            >
                Cancel
            </button>
            </div>
        </div>
    </div>
    <br />
    </v-card>
    <!-- form end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      editId: null,
      deleteId: null,
      dialog: false,
      snackbar: false,
      snackBarText: null,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      applicationValues:null,
      
    };
  },
  components: {},

   computed: {
    ...mapGetters(["currentUser"]),
  },

  methods: {
    getInititalData() {
      AdmissionForm.getStudentApplications()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // main methods
    showEditForm(item) {
      this.applicationValues = JSON.parse(item.values);
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.showFormData = false;
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      CampusService.deleteCampus(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Campus Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    this.getInititalData();
  },
};
</script>

<style scoped>
.text-success {
    color: #2eca8b !important;
}
.text-danger {
    color: #a82511 !important;
}

</style>
